import { Box, Button, FormControl, IconButton, InputAdornment, MenuItem, TextField } from '@mui/material';
import { X } from 'lucide-react';
import React, { useState } from 'react';

interface CreateNewProps {
  type: 'group' | 'tag';
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}
const emptyForm = {
  PartitionKey: '',
  RowKey: '',
  fn: '',
  id: '',
  tag: '',
};
const CreateNew = ({ type, setOpenDialog }: CreateNewProps) => {
  const [form, setForm] = useState(emptyForm);
  const [state, setState] = useState();
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '3% 5%', backgroundColor: 'var(--black01)' }}>
        <h4>Create New {type.charAt(0).toUpperCase() + type.slice(1) ?? 0}</h4>
        <IconButton onClick={() => setOpenDialog(false)}>
          <X size={20} />
        </IconButton>
      </Box>
      <form onReset={() => setForm(emptyForm)} style={{ minWidth: '400px', padding: '5%', display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <TextField label={'Partition Key'} fullWidth value={form.PartitionKey} variant='standard' onChange={e => setForm(prev => ({ ...prev, PartitionKey: e.target.value }))} />
        <TextField label={'Name'} fullWidth value={form.RowKey} variant='standard' size={'small'} onChange={e => setForm(prev => ({ ...prev, RowKey: e.target.value }))} />
        <TextField label={'Fn'} fullWidth value={form.fn} variant='standard' onChange={e => setForm(prev => ({ ...prev, fn: e.target.value }))} />
        <TextField label={'Id'} fullWidth value={form.id} variant='standard' onChange={e => setForm(prev => ({ ...prev, id: e.target.value }))} />
        <TextField label={'Tag'} select fullWidth defaultValue={'tag1'} variant='standard' onChange={e => setForm(prev => ({ ...prev, tag: e.target.value }))}>
          <MenuItem value={'tag1'}>Tag 1</MenuItem>
          <MenuItem value={'tag2'}>Tag 2</MenuItem>
          <MenuItem value={'tag3'}>Tag 3</MenuItem>
          <MenuItem value={'tag4'}>Tag 4</MenuItem>
        </TextField>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '2%' }}>
          <Button variant={'text'} type={'reset'}>
            Reset
          </Button>
          <Button variant={'contained'} type={'submit'}>
            Confirm
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreateNew;
